import React from "react";
import styled, { css } from "styled-components";
import { Field } from "formik";
import { Input } from "components/bootstrap";
const Operator = styled.div(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.spacings.sm};
  `
);
const OperatorField = () => /* @__PURE__ */ React.createElement(Field, { name: "operator" }, ({ field }) => /* @__PURE__ */ React.createElement(Operator, null, /* @__PURE__ */ React.createElement(
  Input,
  {
    type: "radio",
    name: field.name,
    checked: field.value === "AND",
    onChange: field.onChange,
    value: "AND",
    label: "AND",
    formGroupClassName: ""
  }
), /* @__PURE__ */ React.createElement(
  Input,
  {
    type: "radio",
    name: field.name,
    checked: field.value === "OR",
    onChange: field.onChange,
    value: "OR",
    label: "OR",
    formGroupClassName: ""
  }
)));
export default OperatorField;
